import React from "react";
import AllPageFooter from "../../../PreviewPdf/AllPageFooter";
import ReportImage from "../ReportImage";
import { isNullOrWhiteSpace } from "../../utils/reportHelpers";
import { PAGE_TYPES } from "../../model/pageTypes";

const CompanyProfilePage = React.memo(function CompanyProfilePage({
  reportData,
  imageProxyBaseUrl,
  pageNum,
  propLogo,
  pageType,
}) {
  const p = reportData?.propertyInspectionReport?.companyProfile;
  const companyName = p?.companyName ?? "Your Company Name";
  const companyWebsite = p?.companyWebsite ?? "www.yourcompanywebsite.com";
  const companyEmail = p?.companyEmail ?? "-";
  const companyContactNumber = p?.companyContactNumber ?? "-";
  const registationNumber = p?.registationNumber ?? "-";
  const vatNumber = p?.vatNumber ?? "-";
  const companyAddress = p?.companyAddress ?? "-";
  const companyDescription = p?.companyDescription ?? "";
  const accreditations = p?.accreditations ?? [];

  const resolveImageUrl = (imagepath) => {
    if (!imagepath || isNullOrWhiteSpace(imagepath)) return "";
    const url = imagepath.trim();
    if (url.startsWith("data:")) return url;
    if (url.startsWith("http://") || url.startsWith("https://")) {
      return imageProxyBaseUrl + url;
    }
    return url;
  };

  if (pageType === PAGE_TYPES.COMPANY_PROFILE_INFO) {
    return (
      <div className="page sheet">
        <div className="content">
          <h2>Company Information</h2>
          <div className="info-grid">
            <div className="info-item company-info-grid-pos-1-1">
              <span className="label">Company Name</span>
              <span className="value">{companyName}</span>
            </div>
            <div className="info-item company-info-grid-pos-2-1">
              <span className="label">Website</span>
              <span className="value">{companyWebsite}</span>
            </div>
            <div className="info-item company-info-grid-pos-1-2">
              <span className="label">Email Address</span>
              <span className="value">{companyEmail}</span>
            </div>
            <div className="info-item company-info-grid-pos-2-2">
              <span className="label">Contact Number</span>
              <span className="value">{companyContactNumber}</span>
            </div>
            <div className="info-item company-info-grid-pos-1-3">
              <span className="label">Company Registration Number</span>
              <span className="value">{registationNumber}</span>
            </div>
            <div className="info-item company-info-grid-pos-2-3">
              <span className="label">VAT Number</span>
              <span className="value">{vatNumber}</span>
            </div>
            <div className="info-item company-info-grid-pos-1-4">
              <span className="label">Company Address</span>
              <span className="value">{companyAddress}</span>
            </div>
          </div>
        </div>
        <AllPageFooter pageNumber={pageNum} propLogo={propLogo} />
      </div>
    );
  }

  return (
    <div className="page sheet">
      <div className="content">
        <h1>Company Profile</h1>
        <div className="description-text">
          <div dangerouslySetInnerHTML={{ __html: companyDescription }} />
        </div>
        {accreditations.length > 0 && (
          <>
            <h2>Accreditations</h2>
            <div className="accreditation-row">
              {accreditations.map((acc, index) => {
                const image = resolveImageUrl(acc);
                return (
                  <div
                    key={`accreditation-${index}`}
                    className="accreditation-box"
                  >
                    <ReportImage
                      src={image}
                      alt={`Accreditation ${index + 1}`}
                    />
                  </div>
                );
              })}
            </div>
          </>
        )}
      </div>
      <AllPageFooter pageNumber={pageNum} propLogo={propLogo} />
    </div>
  );
});

export default CompanyProfilePage;
